import { PostCheckoutMandatoryQuestionsInAppVariant } from '../../constants/statsig';
import { CheckoutState } from '../../state';
import { getPostCheckoutMandatoryQuestionsInApp } from '../../utils/statsig';
import { getAreMandatoryCustomQuestionsAskedAfterPayment } from './getAreMandatoryCustomQuestionsAskedAfterPayment';
import { getIsPostCheckoutMandatoryQuestionsElegible } from './getIsPostCheckoutMandatoryQuestionsElegible';

export const getEnablePlaceOrderWithoutAnsweringMandatoryQuestions = (
    state: CheckoutState,
) => {
    if (getIsPostCheckoutMandatoryQuestionsElegible(state)) {
        return true;
    }

    const appExperimentVariant = getPostCheckoutMandatoryQuestionsInApp();

    return (
        getAreMandatoryCustomQuestionsAskedAfterPayment(state) ||
        appExperimentVariant ===
            PostCheckoutMandatoryQuestionsInAppVariant.optionalAndCannedQuestionsInApp
    );
};
